import React, { PropsWithChildren, useContext } from 'react'
import { NavigatorContext } from './NavigatorContext'
import { concatStyles } from 'utils'

const DRAWER_SECTION_STYLES = 'flex flex-row list-none relative box-border m-0'

const SECTION_TITLE_STYLES =
  'text-contentareabackground text-base font-heading font-bold m-0 p-4 box-border flex-1 uppercase tracking-wide'

/**
 * A generic container for alternate content embedded in
 * the primary navigation drawer.
 */
export const Section: React.FC<PropsWithChildren> = ({ children }) => {
  const { theme } = useContext(NavigatorContext)

  const DRAWER_BG_STYLE =
    theme === 'secondary'
      ? 'bg-navsectionbackgroundalt'
      : 'bg-navsectionbackground'

  return (
    <li className={concatStyles(DRAWER_SECTION_STYLES, DRAWER_BG_STYLE)}>
      <div className={SECTION_TITLE_STYLES}>{children}</div>
    </li>
  )
}
